import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DataCube from '../data-cube';
import {
  dataCategories,
  humanizeNumber,
  colorMatcher,
} from '../../helpers/formatters';
import styles from './data-cube-row.module.scss';

class DataCubeRow extends Component {
  getCubeData(label, councilData) {
    if (councilData.isBlank && label !== 'relativeRiskAssessment') return '-';

    switch (label) {
      case 'revenue':
        return councilData.revenue.total;
      case 'expenses':
        return councilData.expenses.total;
      case 'assets':
        return councilData.assets.total;
      case 'liabilities':
        return councilData.liabilities.total;
      case 'shareholderReturn':
        return councilData.shareholderReturn.dividendsProvidedForDuringTheYear;
      default:
        return null;
    }
  }
  renderCubes(councilData, type) {
    const { onCubeClick } = this.props;
    const categories = type
      ? dataCategories.filter((category) => category.id !== 'otherInformation')
      : dataCategories;
    return (
      <div
        style={{ marginBottom: type === 'top' ? '45px' : 0 }}
        className={styles.dataCubeRow}
      >
        {categories
          // Universities have no 'other comprehensive income'
          .filter(
            (category) =>
              !(
                category.id === 'other' &&
                councilData.entityCategory === 'Universities'
              )
          )
          .map((category, i) => {
            return (
              <DataCube
                key={i}
                label={category.label}
                value={humanizeNumber(
                  this.getCubeData(category.id, councilData),
                  category.unit
                )}
                type={type}
                color={colorMatcher(category.color)}
                onClick={() => onCubeClick(category.id)}
              />
            );
          })}
      </div>
    );
  }

  renderDoubleRow() {
    const { comparedEntity, activeEntity, onCubeClick } = this.props;
    const otherInformationData = dataCategories.find(
      (category) => category.id === 'otherInformation'
    );
    return (
      <div>
        <div className={styles.dataCubeRowTitle}>{activeEntity.name}</div>
        <div className={styles.cubesDoubleRowWrapper}>
          <div className={styles.cubesDoubleRowComparing}>
            {this.renderCubes(activeEntity, 'top')}
            <div className={styles.dataCubeRowTitle}>{comparedEntity.name}</div>
            {this.renderCubes(comparedEntity, 'bottom')}
          </div>
          {/* No 'other information' cube for QAO Transport */}
          {/* <DataCube
            label={otherInformationData.label}
            text={otherInformationData.text}
            color={colorMatcher(otherInformationData.color)}
            onClick={() => onCubeClick(otherInformationData.id)}
          /> */}
        </div>
      </div>
    );
  }

  render() {
    const { comparedEntity, activeEntity } = this.props;
    return (
      <div className={styles.dataCubeRowWrapper}>
        {comparedEntity
          ? this.renderDoubleRow()
          : this.renderCubes(activeEntity)}
      </div>
    );
  }
}

DataCubeRow.propTypes = {
  activeEntity: PropTypes.object.isRequired,
  comparedEntity: PropTypes.object,
  onCubeClick: PropTypes.func.isRequired,
};

export default DataCubeRow;



// WEBPACK FOOTER //
// ./src/components/data-cube-row/data-cube-row.js